import React, { useContext } from "react";
import "./Intro.css";
import Vector1 from "../../img/Vector1.png";
import Vector2 from "../../img/Vector2.png";
import boy from "../../img/boy.png";
import glassesimoji from "../../img/glassesimoji.png";
import thumbup from "../../img/thumbup.png";
import crown from "../../img/crown.png";
import FloatinDiv from "../FloatingDiv/FloatingDiv";
import Github from "../../img/github.png";
import LinkedIn from "../../img/linkedin.png";
import Instagram from "../../img/instagram.png";
import { themeContext } from "../../Context";
import { motion } from "framer-motion";
const Intro = () => {
  // Transition
  const transition = { duration: 2, type: "spring" };

  // context
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;

  return (
    <div className="Intro" id="Intro">
      {/* left name side */}
      <div className="i-left">
        <div className="i-name">
          {/* yahan change hy darkmode ka */}
          <span style={{ color: darkMode ? "#b0d12a" : "" }}>Welcome To</span>
          <span>Virtual Reality Technology</span>
          <span style={{ color: darkMode ? "white" : "" }}>
            {" "}
            Technological developments cannot be dammed, every second undergoes unnatural changes. Now and in the future life can change drastically because of technology. One of them is a technology that is currently popular, namely
            Virtual Reality (VR Tech). Virtual reality is a technology that allows users or users to interact with an environment in a virtual world that is simulated by a computer, so that users feel they are in that environment.
          </span>
        </div>
        <a href="https://id.wikipedia.org/wiki/Realitas_virtual" smooth={true} spy={true}>
          <button className="button i-button">More..</button>
        </a>
        {/* social icons */}
        <div className="i-icons">
          <a href="https://github.com/LimitMax">
            <img src={Github} alt="Github" />
          </a>
          <a href="https://www.linkedin.com/in/taufiq-qurohman-ruki/">
            <img src={LinkedIn} alt="LinkedIn" />
          </a>
          <a href="https://www.instagram.com/__limitmax/">
            <img src={Instagram} alt="Instagram" />
          </a>
        </div>
      </div>
      {/* right image side */}
      <div className="i-right">
        <img src={Vector1} alt="Blue Neon" />
        <img src={Vector2} alt="Pink Neon" />
        <img src={boy} alt="" style={{ width: "285px", paddingRight: "350px" }} />
        {/* animation */}
        <motion.img initial={{ left: "-36%" }} whileInView={{ left: "3%" }} transition={transition} src={glassesimoji} alt="" />

        <motion.div initial={{ top: "-4%", left: "74%" }} whileInView={{ left: "68%" }} transition={transition} className="floating-div">
          <FloatinDiv img={crown} text1="New" text2="Inovation" />
        </motion.div>

        {/* animation */}
        <motion.div initial={{ left: "9rem", top: "18rem" }} whileInView={{ left: "0rem" }} transition={transition} className="floating-div">
          {/* floatinDiv mein change hy dark mode ka */}
          <FloatinDiv img={thumbup} text1="The Best Tech " text2="of Future" />
        </motion.div>

        <div className="blur" style={{ background: "rgb(238 210 255)" }}></div>
        <div
          className="blur"
          style={{
            background: "#C1F5FF",
            top: "17rem",
            width: "21rem",
            height: "11rem",
            left: "-9rem",
          }}
        ></div>
      </div>
    </div>
  );
};

export default Intro;
